module.exports = __webpack_public_path__ + "img/lqBtn.b12a7d08.png";